<template>
  <div class="not-found">
    <div class="four-o-four">
      404
    </div>
    <div>
      Page not found
    </div>
    <div class="buttons-404">
      <router-link to="/">Go Home</router-link>

      <a class="contact" :href="supportEmail">Contact Support</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      supportEmail: 'mailto:support@timeonline.com'
    };
  }
};
</script>

<style scoped lang="scss">
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 600px;
  .four-o-four {
    font-size: 120pt;
  }
  .buttons-404 {
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    width: 400px;
    .router-link-active,
    .router-link-exact-active {
      text-decoration: none;
      width: 170px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      background-color: #fff;
      padding: 12px 0;
    }

    .contact {
      text-decoration: none;
      width: 170px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 20px;
      padding: 12px 0;
      border: 2px solid white;
      margin-left: auto;
    }
  }
}
</style>
